import * as React from "react";
import type { SVGProps } from "react";
const AgriculturalEquipmentSupplier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_6006)">
      <g clipPath="url(#clip1_4355_6006)">
        <path
          fill="currentColor"
          d="M2.2 5.9996c0-1.3237 1.0763-2.4 2.4-2.4H13c.8888 0 1.665.4838 2.0775 1.2H17.02c.9488 0 1.8075.5588 2.1938 1.425l1.98 4.455c.0187.0413.0337.0788.0487.12H21.4c1.3238 0 2.4 1.0763 2.4 2.4v1.2c.6638 0 1.2.5363 1.2 1.2s-.5362 1.2-1.2 1.2h-1.2c0 1.9875-1.6125 3.6-3.6 3.6s-3.6-1.6125-3.6-3.6h-4.8c0 1.9875-1.6125 3.6-3.6 3.6s-3.6-1.6125-3.6-3.6H2.2c-.6638 0-1.2-.5362-1.2-1.2s.5362-1.2 1.2-1.2v-1.2c-.6638 0-1.2-.5362-1.2-1.2v-3.6c0-.6637.5362-1.2 1.2-1.2zm13.2 4.8h3.2213l-1.6013-3.6H15.4zm-8.4 7.8a1.7998 1.7998 0 0 0 1.2728-3.0728 1.8003 1.8003 0 0 0-2.5456 0A1.8 1.8 0 0 0 7 18.5996m13.8-1.8a1.8 1.8 0 1 0-3.5998-.0001 1.8 1.8 0 0 0 3.5998.0001"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_6006">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_6006">
        <path fill="transparent" d="M1 2.3999h24v19.2H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default AgriculturalEquipmentSupplier;
